<div class="d-flex align-items-center gap-1" *ngIf="!hideButton">
    <button class="vpacs-btn-table" id="button" style="width:85px; height:30px; color:#676a6e; font-size: 11px"
        (click)="btnClickedHandler($event)" [disabled]="bDisabled">{{buttonName}}</button>
</div>

<div class="d-flex align-items-center gap-1" *ngIf="params.data.readystatus !== '4' && hideButton">
    <span>{{text}}</span>
</div>

        